export default __webpack_public_path__ + "static/media/fatherOpen.1abb0441.png";